import styled from '@emotion/styled'
import { css } from '@emotion/react'
import {
  Tab as UnstyledTab,
  TabList as UnstyledTabList,
  Tabs as UnstyledTabs,
  TabPanel as UnstyledTabPanel
} from 'react-tabs'

const tabsStyles = () => css`
  label: tabs;

  background: transparent;
`

const tabListStyles = () => css`
  label: tab__list;

  display: flex;
  padding: 0;
  margin: 0;
`

const tabStyles = ({ theme }) => css`
  label: tab;

  flex-grow: 1;
  padding: ${theme.spacings.byte} 0;
  color: ${theme.colors.n800};
  font-size: ${theme.typography.text.kilo.fontSize};
  text-align: left;
  list-style: none;
  cursor: pointer;
  border-bottom: 3px solid ${theme.colors.n200};

  &:first-child {
    margin-right: ${theme.spacings.mega};
  }

  &.selected {
    label: tab--selected;

    color: ${theme.colors.v500};
    font-weight: ${theme.font.weight.semibold};
    border-color: ${theme.colors.v500};
  }

  &.disabled {
    label: tab--disabled;

    color: ${theme.colors.n100};
    cursor: not-allowed;
  }
`

const tabPanelStyles = ({ theme }) => css`
  label: tab__panel;

  display: none;
  padding: ${theme.spacings.tera} 0;

  span {
    display: block;
    color: ${theme.colors.n500};
    font-size: ${theme.typography.text.kilo.fontSize};
    line-height: ${theme.typography.text.kilo.lineHeight};
  }

  &.selected {
    display: block;
  }
`

const productLinkStyles = ({ theme }) => css`
  label: tab__product-link;

  display: flex;
  align-items: center;
  font-size: ${theme.typography.text.kilo.fontSize};
  line-height: ${theme.typography.text.kilo.lineHeight};
  margin-bottom: ${theme.spacings.tera};
  color: ${theme.colors.p500};

  i {
    margin-top: 1px;
    margin-left: ${theme.spacings.bit};
  }
`

export const ProductLink = styled('a')(productLinkStyles)

export const Tab = styled(UnstyledTab)(tabStyles)
export const Tabs = styled(UnstyledTabs)(tabsStyles)
export const TabPanel = styled(UnstyledTabPanel)(tabPanelStyles)
export const TabList = styled(UnstyledTabList)(tabListStyles)

Tab.tabsRole = 'Tab'
Tabs.tabsRole = 'Tabs'
TabPanel.tabsRole = 'TabPanel'
TabList.tabsRole = 'TabList'
